import { Component, OnInit } from '@angular/core';

 import {session} from '../../../../environments/environment.session'
  @Component({
  selector: '[app-md-footer]',
  templateUrl: './md-footer.component.html',
  styleUrls: ['./md-footer.component.css']
})
export class MdFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
